import React from "react";
import "./style.css";

export const DivWrapper = () => {
  return (
    <div className="div-wrapper">
      <p className="p">
        <span className="text-wrapper-5">
          If you purchased our application through the App Store or Google Play,
          please note that money-back requests must be submitted to the
          respective platform:
          <br />
        </span>
      </p>

      <p className="p">
        <span className="text-wrapper-5">
          App Store Purchases: To request a money-back, please visit{" "}
        </span>

        <a
          href="https://support.apple.com/en-us/HT204084"
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className="text-wrapper-6">Apple&#39;s Support Page</span>
        </a>

        <span className="text-wrapper-7">
          .<br />
        </span>
      </p>

      <p className="p">
        <span className="text-wrapper-5">
          Google Play Purchases: To request a money-back, please visit
        </span>

        <span className="text-wrapper-7">&nbsp;</span>

        <a
          href="https://support.google.com/googleplay/answer/2479637"
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className="text-wrapper-6">Google Play&#39;s Support Page</span>
        </a>

        <span className="text-wrapper-7">
          .<br />
        </span>
      </p>

      <p className="p">
        <span className="text-wrapper-5">
          Thank you for choosing Calo! We greatly appreciate your trust in us
          and are committed to ensuring your satisfaction. For any questions or
          support, please contact us at{" "}
        </span>

        <span className="text-wrapper-6">website@caloapp.ai</span>

        <span className="text-wrapper-5">.</span>
      </p>
    </div>
  );
};
